import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { BiMoneyWithdraw } from "react-icons/bi";
import { ApartmentModal } from "../components/apartment_modal";
import { InventorySupplyModal } from "../components/supply_modal";
import { InventoryDeductModal } from "../components/deduct_modal";
import { MdOutlineAdd, MdOutlineWarehouse } from "react-icons/md";
import { IoSearch } from "react-icons/io5";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { VscDiffAdded } from "react-icons/vsc";



export default function ManageProducts() {
    const navigate = useNavigate();
    const {logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [bookingList, setBookingList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [offset, setOffset] = useState(0);
    const [pagination] = useState('');
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [showApartmentModal, setShowApartmentModal] = useState(false);
    const [pageData, setPageData] = useState({});
    const [showSupplyModal, setShowSupplyModal] = useState(false);
    const [showDeductModal, setShowDeductModal] = useState(false);
    const [itemUpdating, setItem] = useState({});

    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        getData();
    }, [])

    useEffect(() => {
        getData();
    }, [offset])

    useEffect(() => {
        setOffset(0);
        searchData();
    }, [formFields?.category, formFields?.order])

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

    async function getData() {
        const formData = new FormData();
        // Object.entries(formFields).forEach(([key, value]) => {
        //   formData.append(key, value);
        // });
        formData.append('offset', offset);
        if (formFields?.category !== undefined) {
            formData.append('category', formFields?.category);
        }
        if (formFields?.order !== undefined) {
            formData.append('order', formFields?.order);
            formData.append('order_by', formFields?.order_by);
        }
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_products.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
              setPageData(response.data)
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

    async function searchData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('offset', 0);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/get_products.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setBookingList(response.data.records);
              setPageData(response.data)
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {showApartmentModal &&
            <ApartmentModal 
                setShowApartmentModal={setShowApartmentModal}
                getData={getData}
                pageData={pageData}
            />
      }
      {showSupplyModal &&
        <InventorySupplyModal
            setShowSupplyModal={setShowSupplyModal}
            getData={getData}
            item={itemUpdating}
        />
      }
      {showDeductModal &&
        <InventoryDeductModal
            setShowDeductModal={setShowDeductModal}
            getData={getData}
            item={itemUpdating}
        /> 
      }
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#7d5af6'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, Admin`} />
        <div className="py-6 px-6 flex flex-col justify-start">
            <div className="gap-y-2 md:gap-y-0 flex flex-col mb-5 md:flex-row md:items-center justify-between">
                <h2 className="text-xl md:text-2xl text-black font-bold">{'Manage Products'}</h2>
                <div className="flex rounded-xl border p-2 flex-col md:flex-row items-end md:items-center gap-y-2 md:gap-y-0 md:gap-x-2">
                    <button onClick={() => navigate('/dashboard/manage-products/new-product') } className="gap-x-2 bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-5 rounded-xl shadow-md shrink-0 text-sm md:text-md font-cormorant-bold">
                        <VscDiffAdded />
                        <span className="text-white font-cormorant-bold text-sm md:text-md update-price">Add New Product</span>
                    </button>
                </div>
            </div>
            <div className="animate-fadeIn mt-0 w-full bg-white rounded-3xl border p-6 shadow-sm grid grid-cols-2 md:grid-cols-2">
                <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-xs md:text-sm mb-1">
                    <MdOutlineWarehouse className="w-5 h-5" />
                    Avg. Stock Value
                </label>

                <div className="relative">
                    <p className="font-bold text-2xl md:text-3xl">{pageData?.stock_value}</p>
                </div>
                </div>
                <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-xs md:text-sm mb-1">
                    <BiMoneyWithdraw className="w-5 h-5" />
                    Expected Sale Value
                </label>

                <div className="relative">
                    <p className="font-bold text-2xl md:text-3xl">{pageData?.sale_value}</p>
                </div>
                </div>
            </div>
            <div className="gap-y-2 md:gap-y-0 flex flex-col mt-3 md:mt-7 md:flex-row md:items-center justify-between">
                {/* <h2 className="text-xl md:text-2xl text-black font-bold">{'All Products'}</h2> */}
                <div className="flex items-center gap-x-2">
                    <p>Show: </p>
                    <select
                        className="w-auto mx-auto border p-2 rounded my-2"
                        onChange={(e) => setFormFields({...formFields, category: e.target.value})}
                    >
                        <option value="">All Collections</option>
                        {pageData?.categories?.map((item, index) => 
                            <option key={index} value={item.cat_id}>{item.cat_name}</option>
                        )}
                    </select>
                </div>
                <div className="min-w-[30%] flex flex-col md:flex-row items-end md:items-center gap-y-2 md:gap-y-0 md:gap-x-2">
                    <div className="w-full flex items-center justify-between border rounded-xl p-1">
                        <input
                            type="text"
                            placeholder="Enter product name"
                            className="w-full bg-transparent focus:outline-none text-gray-700 px-2"
                            value={formFields?.search}
                            onChange={(e) => {setFormFields({...formFields, search: e.target.value}); }}
                        />
                        <button onClick={() => formFields?.search?.length > 0 ? searchData() : getData() } className="hover:opacity-[0.8] bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-3 rounded-xl shadow-md shrink-0 text-sm md:text-md">
                            <span className="text-white font-cormorant-bold text-sm md:text-md update-price"><IoSearch /></span>
                        </button>
                    </div>
                </div>
            </div>
            <div className='overflow-x-auto mt-5'>
                <table className="w-full table-auto border-collapse text-sm md:text-[15px]">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="hidden md:table-cell px-2 py-4">
                            <div className="flex items-center gap-1">#</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-x-1">
                                Product Name
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'product_name', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "product_name" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'product_name', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "product_name" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex items-center gap-1">Collection</div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Avg. Cost
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'avg_amount', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "avg_amount" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'avg_amount', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "avg_amount" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Base Price
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'base_price', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "base_price" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'base_price', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "base_price" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Revenue
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'total_income', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "total_income" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'total_income', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "total_income" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="hidden md:table-cell text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                Unit(s) Sold
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'no_of_sales', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "no_of_sales" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'no_of_sales', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "no_of_sales" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                In Stock
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'in_stock', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "in_stock" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'in_stock', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "in_stock" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600">
                            <div className="flex justify-between items-center gap-1">
                                In Carts
                                <div className="flex flex-col">
                                    <button onClick={() => setFormFields({...formFields, order_by: 'in_cart', order: 'ASC'})} >
                                        <IoMdArrowDropup color={formFields?.order_by == "in_cart" && formFields?.order == "ASC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                    <button onClick={() => setFormFields({...formFields, order_by: 'in_cart', order: 'DESC'})}>
                                        <IoMdArrowDropdown color={formFields?.order_by == "in_cart" && formFields?.order == "DESC" ? '#585858' : '#bbb'} size={20} />
                                    </button>
                                </div>
                            </div>
                        </th>
                        <th className="text-left px-2 py-4 font-medium text-gray-600"><div className="flex items-center gap-1">Manage Stock</div></th>
                    </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {bookingList?.map((row, index) => (
                            <tr
                            key={index}
                            className={index % 2 === 0 ? "bg-white animate-fadeIn" : "bg-gray-50 animate-fadeIn"}
                            >
                                <td className="hidden md:table-cell px-2 py-2">
                                    {++index}
                                </td>
                                <td className="max-w-[3rem] px-2 py-2 font-semibold">
                                    {row.product_name}
                                </td>
                                <td className="px-2 py-2">
                                    {row.category}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.avg_amount}
                                </td>
                                <td className="px-2 py-2">
                                    {row.base_price}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.total_income}
                                </td>
                                <td className="px-2 py-2">
                                    {row.no_of_sales}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.in_stock}
                                </td>
                                <td className="hidden md:table-cell px-2 py-2">
                                    {row.in_cart}
                                </td>
                                <td className="px-2 py-2">
                                    <div className="flex items-center flex-col md:flex-row gap-y-1 md:gap-y-0 gap-x-1">
                                        <div onClick={() => { setShowSupplyModal(true);setItem(row) }} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-[#037684] bg-[#037684] text-white font-semibold text-center text-xs">{'Quick Add'}</div>
                                        {/* <div onClick={() => { setShowDeductModal(true);setItem(row) }} className="flex items-center justify-center cursor-pointer px-2 py-1 md:px-3 md:py-2 rounded-[5px] border border-1 border-primary bg-primary text-white font-semibold text-center text-xs">{'Deduct'}</div> */}
                                        <div className="">
                                            <a onClick={() => navigate(`/dashboard/manage-products/inventory-history/${row.product_id}/${row.product_name}`, {state: {row}})} className="cursor-pointer underline text-secondary text-sm font-medium p-1">View</a>
                                            <a onClick={() => navigate(`/dashboard/manage-products/edit-product/${row.product_id}`, {state: {row}})} className="cursor-pointer underline text-[#037684] text-sm font-medium p-1">Edit</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='w-full flex justify-end mt-6'>
                <div className='flex flex-col items-center'>
                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-1 py-1 w-fit bg-white">
                        <button
                            onClick={() => changePage('prev')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Prev.
                        </button>
                        <button
                            onClick={() => changePage('next')}
                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                        >
                            Next
                        </button>
                    </div> 
                    <label className='text-sm mt-2'>{pagination}</label>
                </div>
            </div>
        </div>
    </div>
  );
}
